import React from "react";
import { useAuth } from "react-oidc-context";
import { initialize as initializeBaseAPIModelFetcher } from "utils/fetch";
import { initialize as initializeSwitchlessReduxActionFetcher } from "helpers/fetcher";
import { localeStore } from "./store/locale";

export const InitializeFetch = ({ children }) => {
	const ref = React.useRef();
	const auth = useAuth();
	ref.current = auth.user.access_token;
	const connect = {
		getToken: () => ({ token: ref.current })
	};

	localeStore.setUserLocale(
		auth.user.profile.locale || auth.user.profile.data?.locale || "en"
	);

	initializeSwitchlessReduxActionFetcher({
		url: window.weezConfig.api.apiUrl,
		connect
	});

	initializeBaseAPIModelFetcher(window.weezConfig.api.apiUrl, connect);

	return children;
};
